import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const loopzSettings = defineIntegrationSettings({
  fields: {
    enabled: z.boolean(),
    cardDesignId: z.string().trim().nullable(),
    personalMessage: z.string().trim().nullable(),
    creditReason: z.string().trim().nullable(),
    useShopifyFulfillmentLocation: z.boolean(),
  },
  secrets: { apiKey: z.string().trim().min(1, "API key is required") },
  connectOnly: {},
  computed: {
    merchantName: z.string().nullable(),
    programCurrency: z.string().nullable(),
  },
});
